@if (userHas2fa) {
  <div class="container">
    <div class="top-bar">
      <div class="header">
        @if (header) {
          {{ header }}
        } @else {
          <ng-container [ngSwitch]="otpType">
            <ng-container *ngSwitchCase="'Withdraw'"> Wallet </ng-container>
            <ng-container *ngSwitchCase="'BindSocial'"> Connect web3 wallet </ng-container>
            <ng-container *ngSwitchCase="'UnbindSocial'"> Disconnect web3 wallet </ng-container>
            <ng-container *ngSwitchCase="'BindGoogleVerify'"> Disable Authenticator </ng-container>
            <ng-container *ngSwitchDefault> VERIFY </ng-container>
          </ng-container>
        }
      </div>
      <div class="close">
        <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()">
        </cs-icon-button>
      </div>
    </div>
    <div class="content">
      <div class="title">
        @if (title) {
          {{ title }}
        } @else if (isSpecificType === false) {
          Enter One-Time Code
        } @else {
          <ng-container [ngSwitch]="verifyType">
            <ng-container *ngSwitchCase="'EMAIL'">Email Two Step verification </ng-container>
            <ng-container *ngSwitchCase="'GOOGLE'">Google Two Step verification </ng-container>
            <ng-container *ngSwitchCase="'MOBILE'">Mobile Two Step verification </ng-container>
          </ng-container>
        }
      </div>
      <div class="text">
        @if (description) {
          {{ description }}
        } @else {
          <ng-container [ngSwitch]="verifyType">
            <ng-container *ngSwitchCase="'EMAIL'">
              <span> We’ve sent a code to {{ email | maskEmail }}. </span>
              <span class="bold"> Remember to check your 📥️ spam folder! </span>
            </ng-container>
            <ng-container *ngSwitchCase="'GOOGLE'"> Please enter the code from your authenticator app. </ng-container>
            <ng-container *ngSwitchCase="'MOBILE'">We’ve sent a code to {{ mobile }} </ng-container>
          </ng-container>
        }
      </div>
      <div class="digital-code">
        <div class="code-text">Enter your 6 digit code</div>
        <div class="codes">
          <ng-container *ngFor="let code of [].constructor(6); let i = index">
            <div class="code" [class.dash]="!codes[i]">
              <input
                #inputRef
                type="tel"
                inputmode="numeric"
                [disabled]="loading"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
                [attr.data-index]="i"
              />
            </div>
          </ng-container>
        </div>
        @if (hasError && isDirty) {
          <div class="error">Invalid code, please try again</div>
        }
      </div>
      <cs-button
        class="submit"
        size="large"
        [label]="submitText"
        [disabled]="hasError || !allFieldsFilled"
        [loading]="loading"
        (buttonClick)="submit()"
      ></cs-button>
      @if (verifyType !== 'GOOGLE') {
        <div class="button-text">
          @if (isSend) {
            The code has been sent, please wait {{ countdown }} seconds before trying again.
          } @else {
            Didn’t receive your code? <span class="link" (click)="send2fa()">Resend code</span>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <app-cs-confirm-popup
    header="Verification required"
    title="No Two-Factor Authentication Detected"
    message="Please enable a 2FA method in order to perform this action"
    type="error"
    color="accent"
    confirmText="Enable 2FA"
    (confirm)="goToBind2fa()"
  ></app-cs-confirm-popup>
}
